import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ActivatedRoute } from '@angular/router';

//import { SubsidiaryStudentService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-student.service';
//import { SubsidiaryContractService } from 'src/app/services/http/business/subsidiary/dashboard/subsidiary-contract.service';
//import { SubsidiaryPlacementEntryComponent } from '../subsidiary-placement-entry/subsidiary-placement-entry.component';
import { environment } from 'src/environments/environment';
import { CourseService } from 'src/app/services/http/business/course/course.service';
import { RegistrationService } from 'src/app/services/http/business/registration/registration.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { IConfirm } from 'src/app/interfaces/confirm';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { IError } from 'src/app/interfaces/error.interface';


@Component({
  selector: 'app-subsidiary-register-entry',
  templateUrl: './subsidiary-register-entry.component.html',
  styleUrls: ['./subsidiary-register-entry.component.css']
})
export class SubsidiaryRegisterEntryComponent implements OnInit {
  filter: any;
  customer: any;
  dataSource = new MatTableDataSource();
  baseUrl = environment.BaaseUrl;
  errors = new Array();
  errObject: any;
  param: string[];
  errorList: IError[] = [];

  displayedColumns: string[] = [
    this.translate.get("label.level"),
    "branch",
    this.translate.get("label.teacherName"),
    "date",
    this.translate.get("label.pattern"),
    this.translate.get("label.discount"),
    this.translate.get("label.isRegisterd"),
    this.translate.get("label.room"),
    "registred",
    // this.translate.get("label.status"),
    "function"
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  pageIndex: number;
  queryParams: any;
  contract: any;

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
    //private dialog: MatDialog,
    public translate: TranslateService,
    private errorService: ErrorsService,
    // private snackBar: SnackBarService,
    //private subsidiaryStudentService: SubsidiaryStudentService,
    private courseService: CourseService,
    private registrationService: RegistrationService,
    private snackBar: SnackBarService,
    //private subsidiaryContractService: SubsidiaryContractService,
    private dialogRef: MatDialogRef<SubsidiaryRegisterEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
  }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.filter = params["params"];
    });
    // this.getContractById();
    this.refresh();
  }

  register(element: any) {
    this.errors = new Array();
    var xData = {
      CourseId: element.Id,
      CustomerContractId: parseInt(this.data.ContractId),
      CustomerContractNationalId: this.data.Id
    }
    this.registrationService.addAgh(xData).subscribe(() => {
      this.snackBar.OpenSnackBar(
        'ثبت نام با موفقیت انجام شد',
        "ok",
        5000,
        SoundEnum.beep
      );
      this.refresh();
    },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error)
      });
    debugger
  }


  delete(element: any) {
    const confirm: IConfirm = {
      accept: true,
      message: "آیا از حذف دانشجو از کلاس اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "500px",
        data: confirm
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.errors = new Array();
          var data = {
            NationalCode: this.data.Nationalcode,
            CustomerContractId: this.data.ContractId,
            CourseId: element.Id
          }
          this.registrationService.removeAghRegistration(data).subscribe(() => {
            this.snackBar.OpenSnackBar(
              'دانشجو از کلاس حذف گردید',
              "ok",
              5000,
              SoundEnum.beep
            );
            this.refresh();
          })
        }
      });
  }

  // getLevelName(LevelPrerequisiteHolding: any) {
  //   return LevelPrerequisiteHolding.filter(function (e) {
  //     return e.RelationTypeId == 3
  //   })[0].PackageName + ' - ' + LevelPrerequisiteHolding.filter(function (e) {
  //     return e.RelationTypeId == 3
  //   })[0].LevelName
  // }
  // getContractById() {
  //   this.subsidiaryContractService.getContract(this.filter).subscribe(
  //     res => {
  //       this.contract = res.DataList[0];
  //     }
  //   );
  // }

  refresh() {
    debugger
    this.courseService.AghList(this.data.ContractId, this.data.Nationalcode).subscribe(
      res => {
        // this.paginator.pageSize = 10;
        // this.paginator.length = res.Total;
        // this.pageIndex = 0;
        // this.paginator.length = res.Total;
        this.dataSource = new MatTableDataSource(res.DataList);
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  // paginatorEvent(event) {
  //   this.subsidiaryStudentService.getStudentsInContract(this.filter, event.pageIndex + 1, event.pageSize)
  //     .subscribe(res => {
  //       this.pageSize = event.pageSize;
  //       this.paginator.length = res.Total;
  //       this.pageIndex = event.pageIndex + 1;
  //       this.dataSource = new MatTableDataSource(res.DataList);
  //     });
  // }

  // placement(params: any) {

  //   this.dialog.open(SubsidiaryPlacementEntryComponent, {
  //     width: "350px",
  //     data: params,
  //     disableClose: false
  //   })
  //     .afterClosed()
  //     .subscribe(() => {
  //       this.paginatorEvent({ pageSize: this.pageSize, pageIndex: this.pageIndex });
  //     });
  // }

}
